// Each rule is a true/false field of a base policy's portal options, named as the backend's schema
// names it.
export const APP_CONTROL_STANDARD_RULE = {
  HeartbeatDeny: 'heartbeatDeny',
  AllComObjectsTrusted: 'allComObjectsTrusted',
  EdgeSecureEnclave: 'edgeSecureEnclave',
  PfnRule: 'pfnRule',
  Hvci: 'hvci',
};

const APP_CONTROL_STANDARD_RULE_MAPPING = [
  {
    value: APP_CONTROL_STANDARD_RULE.HeartbeatDeny,
    label: 'Heartbeat deny',
    description:
      'Lets the agent raise a block event so we can see the device and its policy are healthy.',
    uncheckedWarning:
      "Devices running this policy send no heartbeat, so the portal can't confirm they or their policy are healthy.",
  },
  {
    value: APP_CONTROL_STANDARD_RULE.AllComObjectsTrusted,
    label: 'All COM objects trusted',
    description: 'Any COM object may be instantiated; its binaries still have to be allowed.',
  },
  {
    value: APP_CONTROL_STANDARD_RULE.EdgeSecureEnclave,
    label: 'Edge secure enclave',
    description: 'Trusts the enclave library Microsoft Edge loads.',
  },
  {
    value: APP_CONTROL_STANDARD_RULE.PfnRule,
    label: 'PFN rule',
    description: 'A packaged app rule, which PFN based supplemental policies need in the base.',
    uncheckedWarning:
      'Packaged app supplemental policies generated against this base will not take effect.',
  },
  {
    value: APP_CONTROL_STANDARD_RULE.Hvci,
    label: 'HVCI',
    description:
      'Turns on memory integrity, so kernel code integrity runs in a hypervisor-protected environment. Incompatible drivers stop loading.',
  },
];

export const getAppControlStandardRuleOptions = () =>
  APP_CONTROL_STANDARD_RULE_MAPPING.map(({ value, label, description }) => ({
    value,
    label,
    description,
  }));

// Every standard rule is on by default, as the portal options' fields.
export const getDefaultAppControlStandardRules = () =>
  Object.fromEntries(APP_CONTROL_STANDARD_RULE_MAPPING.map(item => [item.value, true]));

// What leaving a rule out costs, for the rules where that is worth a caution.
export const getAppControlStandardRuleWarning = (value, checked) =>
  checked
    ? null
    : APP_CONTROL_STANDARD_RULE_MAPPING.find(item => item.value === value)?.uncheckedWarning ??
      null;
